// components/Menu/Menu.jsx
import { useRef, useState, useEffect } from "react";
import Card from "../common/Card";
import { menuImages } from "../utilites/menuimage";

const Menu = () => {
  const [activeCategory, setActiveCategory] = useState("Drinks");
  const [showAll, setShowAll] = useState(false);
  const [loadedImages, setLoadedImages] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [activeSubcategory, setActiveSubcategory] = useState("ALL");

  // Menu items data structure with Chinese dishes
const menuItems = {
    Drinks: [
      {
        name: "Vannila",
        description: "Premium creamy vanilla milkshake made with real vanilla beans and fresh milk",
        price: "SAR 18.00",
        imageKey: "vannila",
        category: "Drinks",
      },
      {
        name: "Chocolate",
        description: "Rich Belgian chocolate milkshake with cocoa powder and whipped cream topping",
        price: "SAR 18.00",
        imageKey: "chocolate",
        category: "Drinks",
      },
      {
        name: "Strawberry",
        description: "Fresh strawberry smoothie blended with Greek yogurt and natural honey",
        price: "SAR 16.00",
        imageKey: "strawberry",
        category: "Drinks",
      },
      {
        name: "Pinapple",
        description: "Freshly squeezed pineapple juice with mint garnish, served chilled",
        price: "SAR 14.00",
        imageKey: "pinapple",
        category: "Drinks",
      },
      {
        name: "Grape",
        description: "100% pure grape juice with chia seeds for added texture",
        price: "SAR 14.00",
        imageKey: "grape",
        category: "Drinks",
      },
      {
        name: "Mint Lime",
        description: "Refreshing mint and lime mocktail with crushed ice and soda water",
        price: "SAR 16.00",
        imageKey: "mintLime",
        category: "Drinks",
      },
    ],
    BreakFast: [
      {
        name: "Porota",
        description: "Crispy layered flatbread freshly made and served hot",
        price: "SAR 8.00",
        imageKey: "porota",
        category: "BreakFast",
      },
      {
        name: "Chapati",
        description: "Soft whole wheat flatbread, perfect with any curry",
        price: "SAR 6.00",
        imageKey: "chapati",
        category: "BreakFast",
      },
      {
        name: "Puri",
        description: "Puffy deep-fried bread served with curry of choice",
        price: "SAR 10.00",
        imageKey: "puri",
        category: "BreakFast",
      },
      {
        name: "Idli",
        description: "Steamed rice cakes served with coconut chutney and sambar",
        price: "SAR 12.00",
        imageKey: "idli",
        category: "BreakFast",
      },
      {
        name: "Dosa",
        description: "Crispy fermented rice crepe served with sambar and chutney",
        price: "SAR 15.00",
        imageKey: "dosa",
        category: "BreakFast",
      },
      {
        name: "Kadala Curry",
        description: "Black chickpeas cooked in rich coconut gravy with spices",
        price: "SAR 14.00",
        imageKey: "kadalaCurry",
        category: "BreakFast",
      },
      {
        name: "Egg Curry",
        description: "Hard-boiled eggs in flavorful onion-tomato gravy",
        price: "SAR 16.00",
        imageKey: "eggCurry",
        category: "BreakFast",
      },
      {
        name: "Veg Mix",
        description: "Mixed vegetables cooked in light gravy with traditional spices",
        price: "SAR 12.00",
        imageKey: "vegMix",
        category: "BreakFast",
      },
      {
        name: "Normal Gravy",
        description: "Traditional South Indian gravy with onions, tomatoes and spices",
        price: "SAR 10.00",
        imageKey: "normalGravy",
        category: "BreakFast",
      },
      {
        name: "Egg Roast",
        description: "Eggs roasted with caramelized onions and blend of spices",
        price: "SAR 16.00",
        imageKey: "eggRoast",
        category: "BreakFast",
      },
    ],
    Lunch: [
      {
        name: "Chicken Biriyani",
        description: "Fragrant basmati rice cooked with tender chicken, saffron and spices",
        price: "SAR 28.00",
        imageKey: "chickenBiriyani",
        category: "Lunch",
      },
      {
        name: "Barik Rice",
        description: "Fine rice preparation served with curry of choice",
        price: "SAR 12.00",
        imageKey: "brickRice",
        category: "Lunch",
      },
      {
        name: "Mata Rice",
        description: "Special rice preparation with mixed vegetables and mild spices",
        price: "SAR 18.00",
        imageKey: "mataRice",
        category: "Lunch",
      },
      {
        name: "Chapati",
        description: "Whole wheat flatbread served with curry",
        price: "SAR 8.00",
        imageKey: "chapati",
        category: "Lunch",
      },
      {
        name: "Porota",
        description: "Flaky layered bread served with curry",
        price: "SAR 10.00",
        imageKey: "porota",
        category: "Lunch",
      },
      {
        name: "Fish Fry",
        description: "Marinated fish fillets deep-fried to crispy perfection",
        price: "SAR 25.00",
        imageKey: "fishFry",
        category: "Lunch",
      },
      {
        name: "Chicken 65",
        description: "Spicy deep-fried chicken chunks marinated with red chili",
        price: "SAR 24.00",
        imageKey: "chicken65",
        category: "Lunch",
      },
      {
        name: "Chicken Khuruma",
        description: "Chicken in rich creamy cashew and coconut gravy",
        price: "SAR 26.00",
        imageKey: "chickenKuruma",
        category: "Lunch",
      },
      {
        name: "Chicken Masala",
        description: "Chicken cooked in traditional onion-tomato masala gravy",
        price: "SAR 25.00",
        imageKey: "chickenMasala",
        category: "Lunch",
      },
    ],
    Dinner: [
      {
        name: "Dosa",
        description: "Crispy rice crepe served with potato filling and chutney",
        price: "SAR 15.00",
        imageKey: "dosa",
        category: "Dinner",
      },
      {
        name: "Porota",
        description: "Layered flatbread served with curry of choice",
        price: "SAR 10.00",
        imageKey: "porota",
        category: "Dinner",
      },
      {
        name: "Chapati",
        description: "Whole wheat bread served with side dish",
        price: "SAR 8.00",
        imageKey: "chapati",
        category: "Dinner",
      },
      {
        name: "Kottu",
        description: "Chopped roti stir-fried with vegetables, eggs and spices",
        price: "SAR 22.00",
        imageKey: "kottu",
        category: "Dinner",
      },
      {
        name: "Biriyani",
        description: "Fragrant rice dish with marinated meat and aromatic spices",
        price: "SAR 28.00",
        imageKey: "chickenBiriyani",
        category: "Dinner",
      },
      {
        name: "Chicken Fried Rice",
        description: "Stir-fried rice with chicken, vegetables and soy sauce",
        price: "SAR 24.00",
        imageKey: "friedRice",
        category: "Dinner",
      },
      {
        name: "Chicken Masala",
        description: "Chicken cooked in rich spicy masala gravy",
        price: "SAR 25.00",
        imageKey: "chickenMasala",
        category: "Dinner",
      },
      {
        name: "Chicken Kuruma",
        description: "Chicken in creamy white gravy with cashews and coconut",
        price: "SAR 26.00",
        imageKey: "chickenKuruma",
        category: "Dinner",
      },
      {
        name: "Chicken 65",
        description: "Crispy spicy deep-fried chicken appetizer",
        price: "SAR 24.00",
        imageKey: "chicken65",
        category: "Dinner",
      },
      {
        name: "Chicken Pepper Masala",
        description: "Chicken cooked in aromatic black pepper sauce",
        price: "SAR 26.00",
        imageKey: "peperMasala",
        category: "Dinner",
      },
      {
        name: "Chicken Kabab",
        description: "Grilled chicken skewers marinated with yogurt and spices",
        price: "SAR 28.00",
        imageKey: "kabab",
        category: "Dinner",
      },
      {
        name: "Omlet",
        description: "Fluffy egg omelette with herbs and spices",
        price: "SAR 10.00",
        imageKey: "omlet",
        category: "Dinner",
      },
    ],
    Chinese: [
      {
        name: "Spring Rolls (Veg)",
        description: "Crispy vegetable rolls served with sweet chili sauce",
        price: "SAR 16.00",
        imageKey: "springRolls",
        category: "Chinese",
        subcategory: "STARTERS"
      },
      {
        name: "Chicken Spring Rolls",
        description: "Crispy rolls filled with minced chicken and vegetables",
        price: "SAR 20.00",
        imageKey: "chickenSpringRolls",
        category: "Chinese",
        subcategory: "STARTERS"
      },
      {
        name: "Chicken Lollipop",
        description: "Crispy fried chicken wings in lollipop style with schezwan sauce",
        price: "SAR 28.00",
        imageKey: "chickenLollipop",
        category: "Chinese",
        subcategory: "STARTERS"
      },
      {
        name: "Chicken Manchurian",
        description: "Fried chicken tossed in sweet-spicy Manchurian sauce",
        price: "SAR 30.00",
        imageKey: "chickenManchurian",
        category: "Chinese",
        subcategory: "STARTERS"
      },
      {
        name: "Chilli Chicken",
        description: "Spicy chicken stir-fried with bell peppers and onions",
        price: "SAR 28.00",
        imageKey: "chilliChicken",
        category: "Chinese",
        subcategory: "STARTERS"
      },
      {
        name: "Chicken Hakka Noodles",
        description: "Stir-fried noodles with chicken and vegetables in soy sauce",
        price: "SAR 26.00",
        imageKey: "hakkaNoodles",
        category: "Chinese",
        subcategory: "NOODLES"
      },
      {
        name: "Veg Hakka Noodles",
        description: "Vegetable stir-fried noodles with soy sauce and spices",
        price: "SAR 22.00",
        imageKey: "vegHakkaNoodles",
        category: "Chinese",
        subcategory: "NOODLES"
      },
      {
        name: "Chicken Chow Mein",
        description: "Pan-fried noodles with chicken and assorted vegetables",
        price: "SAR 26.00",
        imageKey: "chowMein",
        category: "Chinese",
        subcategory: "NOODLES"
      },
      {
        name: "Singapore Noodles",
        description: "Curry flavored rice noodles with vegetables and protein",
        price: "SAR 28.00",
        imageKey: "singaporeNoodles",
        category: "Chinese",
        subcategory: "NOODLES"
      },
      {
        name: "Steamed Chicken Momos",
        description: "Steamed dumplings with chicken filling and spicy sauce",
        price: "SAR 22.00",
        imageKey: "steamedMomos",
        category: "Chinese",
        subcategory: "MOMOS"
      },
      {
        name: "Fried Chicken Momos",
        description: "Crispy fried dumplings with chicken filling",
        price: "SAR 25.00",
        imageKey: "friedMomos",
        category: "Chinese",
        subcategory: "MOMOS"
      },
      {
        name: "Veg Steamed Momos",
        description: "Steamed dumplings with mixed vegetable filling",
        price: "SAR 20.00",
        imageKey: "vegMomos",
        category: "Chinese",
        subcategory: "MOMOS"
      },
      {
        name: "Chicken Fried Rice",
        description: "Fragrant fried rice with chicken, eggs and spring onions",
        price: "SAR 26.00",
        imageKey: "chickenFriedRice",
        category: "Chinese",
        subcategory: "RICE"
      },
      {
        name: "Egg Fried Rice",
        description: "Classic fried rice with scrambled eggs and vegetables",
        price: "SAR 22.00",
        imageKey: "eggFriedRice",
        category: "Chinese",
        subcategory: "RICE"
      },
      {
        name: "Veg Fried Rice",
        description: "Vegetable fried rice with soy sauce and seasoning",
        price: "SAR 20.00",
        imageKey: "vegFriedRice",
        category: "Chinese",
        subcategory: "RICE"
      },
      {
        name: "Chicken Schezwan Rice",
        description: "Spicy schezwan style fried rice with chicken",
        price: "SAR 28.00",
        imageKey: "schezwanRice",
        category: "Chinese",
        subcategory: "RICE"
      },
      {
        name: "Veg Manchurian",
        description: "Vegetable balls in sweet-spicy Manchurian sauce",
        price: "SAR 24.00",
        imageKey: "vegManchurian",
        category: "Chinese",
        subcategory: "VEGETARIAN"
      },
      {
        name: "American Chop Suey",
        description: "Crispy noodles topped with vegetables in sweet-sour sauce",
        price: "SAR 24.00",
        imageKey: "chopSuey",
        category: "Chinese",
        subcategory: "VEGETARIAN"
      },
      {
        name: "Chilli Paneer",
        description: "Cottage cheese cubes in spicy chilli garlic sauce",
        price: "SAR 26.00",
        imageKey: "chilliPaneer",
        category: "Chinese",
        subcategory: "VEGETARIAN"
      },
      {
        name: "Schezwan Noodles",
        description: "Spicy noodles with vegetables in fiery schezwan sauce",
        price: "SAR 26.00",
        imageKey: "schezwanNoodles",
        category: "Chinese",
        subcategory: "SPICY"
      },
      {
        name: "Schezwan Chicken",
        description: "Chicken in fiery schezwan sauce with bell peppers",
        price: "SAR 32.00",
        imageKey: "schezwanChicken",
        category: "Chinese",
        subcategory: "SPICY"
      },
      {
        name: "Hot Garlic Chicken",
        description: "Chicken in garlic, soy and chili sauce",
        price: "SAR 30.00",
        imageKey: "garlicChicken",
        category: "Chinese",
        subcategory: "SPICY"
      },
      {
        name: "Chicken Noodle Soup",
        description: "Clear soup with chicken, noodles and vegetables",
        price: "SAR 18.00",
        imageKey: "noodleSoup",
        category: "Chinese",
        subcategory: "SOUP"
      },
      {
        name: "Sweet Corn Soup",
        description: "Creamy sweet corn soup with egg drop",
        price: "SAR 16.00",
        imageKey: "cornSoup",
        category: "Chinese",
        subcategory: "SOUP"
      },
      {
        name: "Manchow Soup",
        description: "Spicy vegetable soup topped with crispy noodles",
        price: "SAR 18.00",
        imageKey: "manchowSoup",
        category: "Chinese",
        subcategory: "SOUP"
      },
    ],
  };

  // Get all menu items flattened
  const allMenuItems = Object.values(menuItems).flat();

  // Load images dynamically when needed
  useEffect(() => {
    const loadImages = async () => {
      setIsLoading(true);
      const imagesToLoad = [];
      
      // Only load images for current category
      if (!showAll) {
        const currentItems = getCurrentItems();
        currentItems.forEach(item => {
          if (item.imageKey && !loadedImages[item.imageKey]) {
            imagesToLoad.push(item.imageKey);
          }
        });
      } else {
        // Load all images when showAll is true
        allMenuItems.forEach(item => {
          if (item.imageKey && !loadedImages[item.imageKey]) {
            imagesToLoad.push(item.imageKey);
          }
        });
      }

      // Load images in parallel for better performance
      const imagePromises = imagesToLoad.map(async (imageKey) => {
        try {
          const module = await menuImages[imageKey]();
          return { key: imageKey, src: module.default };
        } catch (error) {
          console.error(`Failed to load image: ${imageKey}`, error);
          return null;
        }
      });

      const results = await Promise.all(imagePromises);
      
      const newLoadedImages = { ...loadedImages };
      results.forEach(result => {
        if (result) {
          newLoadedImages[result.key] = result.src;
        }
      });
      
      setLoadedImages(newLoadedImages);
      setIsLoading(false);
    };

    loadImages();
  }, [activeCategory, showAll, activeSubcategory]);

  // Helper to get image src
  const getImageSrc = (imageKey) => {
    return loadedImages[imageKey] || null;
  };

  const handleCategoryChange = (category) => {
    setActiveCategory(category);
    setActiveSubcategory("ALL"); // Reset subcategory filter
    setShowAll(false);
  };

  // Get current items to display
  const getCurrentItems = () => {
    if (showAll) {
      return allMenuItems;
    }
    
    if (activeCategory === "Chinese" && activeSubcategory !== "ALL") {
      return menuItems[activeCategory].filter(item => 
        item.subcategory === activeSubcategory
      );
    }
    
    return menuItems[activeCategory] || [];
  };

  // Get subcategories for Chinese category
  const getChineseSubcategories = () => {
    if (activeCategory !== "Chinese") return [];
    
    const subcategories = new Set();
    menuItems.Chinese.forEach(item => {
      if (item.subcategory) {
        subcategories.add(item.subcategory);
      }
    });
    return Array.from(subcategories);
  };

  // Handle subcategory change
  const handleSubcategoryChange = (subcategory) => {
    setActiveSubcategory(subcategory);
  };

  // Get category display name
  const getCategoryDisplayName = (category) => {
    const names = {
      Drinks: "Drinks",
      BreakFast: "Breakfast",
      Lunch: "Lunch",
      Dinner: "Dinner",
      Chinese: "Chinese",
    };
    return names[category] || category;
  };

  // Add this ref at the component level
  const menuTopRef = useRef(null);

  const handleViewAll = () => {
    const newShowAll = !showAll;
    setShowAll(newShowAll);
    setActiveSubcategory("ALL"); // Reset subcategory filter when viewing all

    // Scroll to appropriate position with animation
    setTimeout(() => {
      const menuSection = document.getElementById("menu");
      if (menuSection) {
        if (newShowAll) {
          // When clicking "View All", scroll to menu section top
          menuSection.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        } else {
          // When clicking "View Categories", scroll to the tab bar
          const menuTopElement = document.getElementById("menu-top");
          if (menuTopElement) {
            menuTopElement.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          } else {
            // Fallback to menu section
            menuSection.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }
      }
    }, 300);
  };

  return (
    <section id="menu" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12" ref={menuTopRef} id="menu-top">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-secondary mb-6">
             Our <span className="text-primary">Menu</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto font-body">
            Discover our carefully crafted dishes made with the finest
            ingredients and innovative techniques.
          </p>
        </div>

        {/* Modern Tab Bar with Indicator - REMOVED sticky */}
        <div className="mb-12 bg-gray-50 py-4 rounded-xl shadow-lg transition-all duration-500 border border-gray-100">
          <div className="relative">
            <div className="flex overflow-x-auto no-scrollbar pb-2">
              <div className="flex space-x-1 mx-auto">
                {["Drinks", "BreakFast", "Lunch", "Dinner", "Chinese"].map((category) => (
                  <button
                    key={category}
                    className={`relative px-6 py-4 font-body font-medium transition-all duration-500 whitespace-nowrap ${
                      activeCategory === category && !showAll
                        ? "text-primary transform scale-105"
                        : "text-gray-500 hover:text-gray-700"
                    } ${showAll ? "opacity-50" : "opacity-100"}`}
                    onClick={() => handleCategoryChange(category)}
                    disabled={showAll}
                  >
                    {getCategoryDisplayName(category)}
                    {activeCategory === category && !showAll && (
                      <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-3/4 h-1 bg-primary rounded-full transition-all duration-500"></span>
                    )}
                  </button>
                ))}
              </div>
            </div>

            {/* Animated tab indicator for View All state */}
            {showAll && (
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-primary/30 to-transparent opacity-0 animate-pulse"></div>
            )}
          </div>
        </div>

        {/* Chinese Subcategory Filter */}
        {activeCategory === "Chinese" && !showAll && (
          <div className="mb-10">
            <div className="flex flex-wrap justify-center gap-2">
              {["ALL", ...getChineseSubcategories()].map((subcat) => (
                <button
                  key={subcat}
                  className={`px-4 py-2 rounded-full text-sm font-body font-medium transition-all duration-300 ${
                    activeSubcategory === subcat
                      ? "bg-primary text-white shadow-md transform scale-105"
                      : "bg-gray-100 text-gray-600 hover:bg-gray-200 hover:shadow"
                  }`}
                  onClick={() => handleSubcategoryChange(subcat)}
                >
                  {subcat}
                </button>
              ))}
            </div>
            <p className="text-center text-gray-500 text-sm mt-4 font-body">
              Showing {activeSubcategory === "ALL" 
                ? "all" 
                : activeSubcategory.toLowerCase()} dishes • {getCurrentItems().length} items
            </p>
          </div>
        )}

        {/* View All Header - Now positioned below tabs */}
        <div
          className={`text-center mb-12 transition-all duration-700 ease-in-out transform ${
            showAll
              ? "opacity-100 translate-y-0 max-h-40"
              : "opacity-0 -translate-y-4 max-h-0 overflow-hidden"
          }`}
        >
          <div className="inline-block px-6 py-2 bg-primary/10 rounded-full mb-4">
            <span className="text-sm font-body font-medium text-primary">
              Full Menu Preview
            </span>
          </div>
          <h3 className="text-2xl md:text-3xl font-display font-bold text-gray-800">
            Explore Our Complete Collection
          </h3>
          <p className="text-gray-600 mt-2 font-body max-w-2xl mx-auto">
            Showing all {allMenuItems.length} carefully crafted items across all
            categories
          </p>
        </div>

        {/* Loading skeleton */}
        {isLoading && (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[...Array(showAll ? allMenuItems.length : getCurrentItems().length || 6)].map((_, index) => (
              <div key={index} className="animate-pulse">
                <div className="bg-white rounded-lg shadow-md border border-gray-100 h-full overflow-hidden">
                  <div className="w-full h-64 bg-gray-200"></div>
                  <div className="p-6">
                    <div className="flex justify-between mb-3">
                      <div className="h-6 bg-gray-200 rounded w-3/4"></div>
                      <div className="h-6 bg-gray-200 rounded w-1/4"></div>
                    </div>
                    <div className="h-4 bg-gray-200 rounded w-full mt-4"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Menu Items Grid */}
        {!isLoading && (
          <>
            {/* Chinese category with subcategories (when ALL is selected) */}
            {activeCategory === "Chinese" && !showAll && activeSubcategory === "ALL" ? (
              <div className="space-y-12">
                {getChineseSubcategories().map((subcategory) => {
                  const items = menuItems.Chinese.filter(item => item.subcategory === subcategory);
                  if (items.length === 0) return null;

                  return (
                    <div key={subcategory} className="animate-fadeInUp">
                      {/* Subcategory Header */}
                      <div className="flex items-center mb-8">
                        <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
                        <div className="mx-6 text-center">
                          <h3 className="text-2xl font-display font-bold text-gray-800">
                            {subcategory}
                          </h3>
                          <p className="text-gray-500 text-sm mt-1 font-body">
                            {items.length} items
                          </p>
                        </div>
                        <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
                      </div>
                      
                      {/* Items Grid */}
                      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {items.map((item, index) => (
                          <div
                            key={index}
                            className="transform transition-all duration-700 ease-out"
                          >
                            <Card className="hover:shadow-xl transition-all duration-500 ease-in-out group relative bg-white transform hover:-translate-y-2 h-full border border-gray-100 overflow-hidden">
                              {/* Image Container */}
                              <div className="w-full h-64 bg-gray-50 rounded-t-lg flex justify-center items-center border-b border-gray-200 overflow-hidden relative">
                                {getImageSrc(item.imageKey) ? (
                                  <>
                                    <img
                                      src={getImageSrc(item.imageKey)}
                                      alt={item.name}
                                      className="max-h-full max-w-full object-cover transition-all duration-700 group-hover:scale-110 group-hover:rotate-1"
                                      loading="lazy"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                                  </>
                                ) : (
                                  <div className="w-full h-full bg-gray-200 animate-pulse flex items-center justify-center">
                                    <span className="text-gray-400">Loading image...</span>
                                  </div>
                                )}
                              </div>

                              {/* Text Content */}
                              <div className="p-6">
                                <div className="flex justify-between items-start mb-3">
                                  <h3 className="text-xl font-display font-semibold text-gray-800 transition-colors duration-300 group-hover:text-primary line-clamp-1">
                                    {item.name}
                                  </h3>
                                  <span className="text-secondary font-bold font-body text-lg whitespace-nowrap ml-4">
                                    {item.price}
                                  </span>
                                </div>

                                {/* Description with fade-in */}
                                <div className="mt-4 transform transition-all duration-500 translate-y-2 group-hover:translate-y-0">
                                  <p className="text-gray-600 text-sm font-body opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                                    {item.description}
                                  </p>
                                </div>

                                {/* Chinese cuisine tag */}
                                <div className="mt-4">
                                  <span className="inline-block px-3 py-1 bg-red-50 text-red-600 text-xs font-medium rounded-full border border-red-100">
                                    {subcategory}
                                  </span>
                                </div>
                              </div>
                            </Card>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              /* Regular grid for other categories or filtered Chinese */
              <div
                className={`grid md:grid-cols-2 lg:grid-cols-3 gap-8 transition-all duration-1000 ease-in-out ${
                  showAll ? "opacity-100" : "opacity-100"
                }`}
              >
                {getCurrentItems().map((item, index) => (
                  <div
                    key={index}
                    className={`transform transition-all duration-700 ease-out ${
                      showAll ? "animate-fadeInUp" : ""
                    }`}
                    style={{
                      animationDelay: showAll ? `${index * 0.08}s` : "0s",
                      animationFillMode: "forwards",
                      opacity: showAll ? 0 : 1,
                    }}
                  >
                    <Card className="hover:shadow-xl transition-all duration-500 ease-in-out group relative bg-white transform hover:-translate-y-2 h-full border border-gray-100 overflow-hidden">
                      {/* Category Badge with improved animation */}
                      <div
                        className={`absolute top-4 left-4 z-10 transition-all duration-700 ${
                          showAll
                            ? "opacity-100 transform translate-y-0"
                            : "opacity-0 transform -translate-y-4"
                        }`}
                      >
                        <span className="bg-gradient-to-r from-primary to-secondary text-white px-4 py-2 rounded-full text-xs font-body font-medium shadow-md">
                          {getCategoryDisplayName(item.category)}
                        </span>
                      </div>

                      {/* Image Container */}
                      <div className="w-full h-64 bg-gray-50 rounded-t-lg flex justify-center items-center border-b border-gray-200 overflow-hidden relative">
                        {getImageSrc(item.imageKey) ? (
                          <>
                            <img
                              src={getImageSrc(item.imageKey)}
                              alt={item.name}
                              className="max-h-full max-w-full object-cover transition-all duration-700 group-hover:scale-110 group-hover:rotate-1"
                              loading="lazy"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                          </>
                        ) : (
                          <div className="w-full h-full bg-gray-200 animate-pulse flex items-center justify-center">
                            <span className="text-gray-400">Loading image...</span>
                          </div>
                        )}
                      </div>

                      {/* Text Content */}
                      <div className="p-6">
                        <div className="flex justify-between items-start mb-3">
                          <h3 className="text-xl font-display font-semibold text-gray-800 transition-colors duration-300 group-hover:text-primary line-clamp-1">
                            {item.name}
                          </h3>
                          <span className="text-secondary font-bold font-body text-lg whitespace-nowrap ml-4">
                            {item.price}
                          </span>
                        </div>

                        {/* Description with fade-in */}
                        <div className="mt-4 transform transition-all duration-500 translate-y-2 group-hover:translate-y-0">
                          <p className="text-gray-600 text-sm font-body opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                            {item.description ||
                              "Delicious dish made with fresh ingredients and authentic flavors."}
                          </p>
                        </div>

                        {/* Subcategory badge for Chinese items in View All */}
                        {showAll && item.category === "Chinese" && item.subcategory && (
                          <div className="mt-4">
                            <span className="inline-block px-3 py-1 bg-red-50 text-red-600 text-xs font-medium rounded-full border border-red-100">
                              {item.subcategory}
                            </span>
                          </div>
                        )}
                      </div>

                      {/* Floating indicator for View All */}
                      {showAll && (
                        <div className="absolute top-2 right-2 w-2 h-2 bg-green-500 rounded-full animate-ping opacity-75"></div>
                      )}
                    </Card>
                  </div>
                ))}
              </div>
            )}
          </>
        )}

        {/* No items message */}
        {!isLoading && getCurrentItems().length === 0 && (
          <div className="text-center py-16 transition-all duration-1000">
            <div className="w-20 h-20 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
              <span className="text-3xl">🍽️</span>
            </div>
            <h4 className="text-xl font-display font-semibold text-gray-700 mb-2">
              No items found
            </h4>
            <p className="text-gray-500 font-body">
              {activeCategory === "Chinese" && activeSubcategory !== "ALL"
                ? `No items in ${activeSubcategory} category`
                : "Try selecting a different category"}
            </p>
          </div>
        )}

        {/* View All / View Categories Button */}
        {!isLoading && (
          <div className="text-center mt-16 relative">
            <div className="absolute top-1/2 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent transform -translate-y-1/2"></div>

            <button
              onClick={handleViewAll}
              className="relative bg-gradient-to-r from-primary to-secondary text-white px-10 py-4 rounded-full font-body font-medium hover:shadow-xl transform hover:scale-105 transition-all duration-500 ease-in-out shadow-lg group overflow-hidden z-10"
            >
              <span className="absolute inset-0 bg-gradient-to-r from-secondary to-primary opacity-0 group-hover:opacity-100 transition-opacity duration-500"></span>

              <span className="relative z-10 flex items-center justify-center space-x-3">
                <span className="text-lg font-semibold">
                  {showAll ? "Browse Categories" : "View Complete Menu"}
                </span>
                <span
                  className={`transform transition-transform duration-500 ${
                    showAll ? "rotate-180" : ""
                  }`}
                >
                  {showAll ? "↑" : "↓"}
                </span>
              </span>

              <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-500"></span>
            </button>

            <p className="text-gray-500 text-sm mt-4 font-body transition-all duration-500">
              {showAll
                ? "Return to categorized view"
                : `View all ${allMenuItems.length} items in one place`}
            </p>
          </div>
        )}
      </div>

      {/* Add smooth scrolling globally */}
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fadeInUp {
          animation: fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1) forwards;
        }

        /* Custom scrollbar for menu items */
        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }

        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }

        /* Line clamp utility */
        .line-clamp-1 {
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </section>
  );
};

export default Menu;